import { CommonAction } from '../../../message/redux/types';
import ConstantsTypes, { ConstantsState } from './types';

const constantsInitialState: ConstantsState = {
    constants: {
        idTypes: [],
        individualAccreditation: [],
        institutionalAccreditation: [],
        nationalities: [],
        residentialStatus: [],
        countries: [],
    },
};

const ConstantsReducer = (state = constantsInitialState, action: CommonAction): ConstantsState => {
    switch (action.type) {
        case ConstantsTypes.SET_CONSTANTS:
            return {
                ...state,
                constants: action.payload,
            };
        default:
            return state;
    }
};

export default ConstantsReducer;
